export default {
  setGoodFlows(state, value) {
    state.goodFlows = value
  },
  updateGoodFlows(state, value) {
    state.goodFlows = value
  },
  setFlowFilters(state, value) {
    state.flowFilters = value
  },
  setCount(state, value) {
    state.count = value
  },
  setGoodFlow(state, value) {
    state.goodFlow = value
  },
  setGoodFlowParam(state, obj) {
    if (state.goodFlow) {
      state.goodFlow = { ...state.goodFlow, ...obj }
    }
  },
  setFlowTypes(state, value) {
    state.flowTypes = value
  },
  setFlowType(state, value) {
    state.flowType = value
  },
  setFlowStatuses(state, value) {
    state.flowStatuses = value
  },
  setFlowItems(state, value) {
    state.flowItems = value
  },
  setQtyUnits(state, value) {
    state.qtyUnits = value
  },
  setFlowItemsCount(state, value) {
    state.flowItemsCount = value
  },
  addFlowItem(state, obj) {
    state.flowItems.unshift(obj)
  },
  setFlowItem(state, obj) {
    for (let i = 0; i < state.flowItems.length; i++) {
      if (state.flowItems[i].id === obj.id) {
        state.flowItems.splice(i, 1, obj)
        break
      }
    }
  },
  delFlowItem(state, val) {
    for (let i = 0; i < state.flowItems.length; i++) {
      if (state.flowItems[i].id === val) {
        state.flowItems.splice(i, 1)
        break
      }
    }
  },
}
